import React, { useEffect, useState } from "react";
import { Layers, ClipboardCheck, Clock, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import OfficerShell from "./OfficerShell";
import TehsilOfficeDashboard from "./TehsilOfficeDashboard";
import { SdoReviewQueue, TEH_LABEL } from "./SdoDashboard";
import { RdcMarkingTab } from "./RdcDashboard";

const TITLE = {
  sdo: "उपविभागीय अधिकारी डॅशबोर्ड",
  rdc: "निवासी उपजिल्हाधिकारी डॅशबोर्ड",
};

export default function OfficerTabbedDashboard({ role }) {
  const [view, setView] = useState("dash");
  const [meta, setMeta] = useState(null);
  const [prelim, setPrelim] = useState(null);
  const [tab, setTab] = useState("");

  useEffect(() => {
    api.officerMeta().then((m) => {
      setMeta(m);
      const ts = m.scopeTehsils || [];
      if (ts.length) setTab(ts[0]);
    }).catch(() => {});
    api.officerPrelimStats().then(setPrelim).catch(() => {});
  }, []);

  const tehsils = (meta && meta.scopeTehsils) || [];

  return (
    <OfficerShell>
      <div className="mb-5">
        <h1 className="font-head text-[26px] font-medium text-[#1b5e3f]">{TITLE[role] || "अधिकारी डॅशबोर्ड"}</h1>
        <p className="text-[14px] text-slate-500">क्षेत्र: {meta?.jurisdiction || "—"} · तहसील कार्यालयनिहाय अर्ज स्थिती व अपात्र अर्जांची पडताळणी</p>
      </div>

      <div className="mb-5 flex gap-2">
        <button onClick={() => setView("dash")} data-testid="officer-view-dash"
          className={`rounded-full px-5 py-2 text-[13.5px] font-semibold transition-colors ${view === "dash" ? "bg-[#1b5e3f] text-white" : "bg-white text-slate-600 ring-1 ring-slate-300 hover:bg-slate-50"}`}>डॅशबोर्ड</button>
        <button onClick={() => setView("verify")} data-testid="officer-view-verify"
          className={`rounded-full px-5 py-2 text-[13.5px] font-semibold transition-colors ${view === "verify" ? "bg-[#1b5e3f] text-white" : "bg-white text-slate-600 ring-1 ring-slate-300 hover:bg-slate-50"}`}>प्राथमिक पडताळणी</button>
        <button onClick={() => setView("marking")} data-testid="officer-view-marking"
          className={`rounded-full px-5 py-2 text-[13.5px] font-semibold transition-colors ${view === "marking" ? "bg-[#1b5e3f] text-white" : "bg-white text-slate-600 ring-1 ring-slate-300 hover:bg-slate-50"}`}>गुणांकन</button>
      </div>

      {view === "dash" && <TehsilOfficeDashboard showSdo={role !== "sdo"} />}
      {view === "marking" && <RdcMarkingTab role={role === "sdo" ? "sdo" : "rdc"} />}

      {view === "verify" && (
        <>
          {prelim && (
            <div className="mb-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {[
                { icon: Layers, label: "एकूण अर्ज", value: prelim.total, color: "text-[#1b5e3f]" },
                { icon: CheckCircle2, label: "पडताळणी झालेले", value: prelim.done, color: "text-emerald-600" },
                { icon: Clock, label: "प्रलंबीत", value: prelim.pending, color: "text-amber-600" },
                { icon: ClipboardCheck, label: "तालुके", value: tehsils.length, color: "text-[#c2570a]" },
              ].map((s, i) => (
                <div key={i} className="rounded-xl border border-[#e6dcc4] bg-white p-4">
                  <s.icon className={`mb-1.5 h-5 w-5 ${s.color}`} />
                  <p className={`text-[24px] font-bold ${s.color}`}>{s.value}</p>
                  <p className="text-[12.5px] text-slate-500">{s.label}</p>
                </div>
              ))}
            </div>
          )}

          <div className="mb-5 flex flex-wrap gap-2">
            {tehsils.map((t) => (
              <button key={t} onClick={() => setTab(t)} data-testid={`officer-taluka-tab-${t}`}
                className={`rounded-full px-5 py-2 text-[13.5px] font-semibold transition-colors ${tab === t ? "bg-[#c2570a] text-white" : "bg-white text-slate-600 ring-1 ring-slate-300 hover:bg-slate-50"}`}>
                {TEH_LABEL[t] || t}
              </button>
            ))}
          </div>

          {tab && (
            <div className="rounded-2xl border border-[#e6dcc4] bg-white p-5">
              <p className="mb-1 text-[15px] font-bold text-[#1b5e3f]">{TEH_LABEL[tab] || tab} तहसील — प्राथमिक पडताळणी</p>
              <SdoReviewQueue key={tab} tehsil={tab} />
            </div>
          )}
        </>
      )}
    </OfficerShell>
  );
}
